import "./ProjectsPage2.module.css";
import Header from "@/reusable_sections/Header";
import ProjectHero from "./sections/ProjectHero";
import ProjectsOverview from "./sections/ProjectsOverview";
import OurPartners from "./sections/OurPartners";
import GetInTouch from "./sections/GetInTouch";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsPage2() {
  return <div>
      <Header />
      <ProjectHero />
      <ProjectsOverview />
      <OurPartners />
      <GetInTouch />
      <Footer />
    </div>;
}